export const GET_RATING_CODES_REQUEST = 'GET_RATING_CODES_REQUEST';

export const getRatingCodesRequest = () => ({
    type: GET_RATING_CODES_REQUEST,
});
